export enum RewardBannerButtonAction {
  Story = 'story',
  Chat = 'chat',
}

export enum RewardBannerPrizeType {
  Hearts = 'hearts',
  Sapphires = 'sapphires',
  None = '',
}

export interface RewardBannerPrize {
  prizeType: RewardBannerPrizeType;
  prizeValue: string;
}

export interface RewardBanner {
  id: number;
  promotionId: number;
  title: string;
  description: string;
  imageUrl: string;
  active: boolean;
  priority: number;
  startTime: string | null;
  endTime: string | null;
  label: string;
  prize: string | null;
  buttonText: string;
  buttonAction: RewardBannerButtonAction;
  buttonTarget: string;
  specialRequirements: string;
  /** Optional Event Shelf fields; the API omits each one when it is unset. */
  cardImageUrl?: string;
  detailImageUrl?: string;
  ringColor?: string;
  createdAt: string;
  updatedAt: string;
}

export interface RewardBannerResponse {
  success: boolean;
  rewardBanner: RewardBanner | null;
}

export interface RewardBannerCoverFile {
  fileName: string;
  file: Blob;
}

export interface RewardBannerFormValues {
  id?: number;
  title: string;
  description: string;
  label: string;
  priority: number;
  buttonText: string;
  specialRequirements: string;
  buttonAction: RewardBannerButtonAction;
  buttonTarget: string;
  prize: RewardBannerPrize;
  active: boolean;
  imageUrl: string;
  newCoverImage?: RewardBannerCoverFile;
  /** Pending card-icon upload. Its URL is display-only and is never submitted. */
  newCardImage?: RewardBannerCoverFile;
  /** Pending modal-cover upload. Its URL is display-only and is never submitted. */
  newModalImage?: RewardBannerCoverFile;
  /** Current card icon from the banner GET response, or a local preview after an upload. */
  cardImageUrl: string;
  /** Current modal cover from the banner GET response, or a local preview after an upload. */
  detailImageUrl: string;
  /** Empty represents the app default; non-empty is a #RGB or #RRGGBB override. */
  ringColor: string;
  /** Distinguishes untouched (omit from multipart) from explicitly cleared (send ''). */
  ringColorTouched: boolean;
  /** Sends removeCardImage="1" when an existing card icon was deliberately removed. */
  removeCardImage: boolean;
  /** Sends removeModalImage="1" when an existing modal cover was deliberately removed. */
  removeModalImage: boolean;
}
